import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=7bdf3ed2&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=js&"
export * from "./questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=7bdf3ed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf3ed2",
  null
  
)

export default component.exports